import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Always look for the gem",
  "description": "",
  "published": "2013-07-23T00:00:00.000Z",
  "redirect_from": ["/blog/always-look-for-the-gem/swizec/6287"],
  "categories": "Programming, Ruby, Tools, Uncategorized, Web Design and Development",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can be doing something straightforward. Say, listing some items from the database and giving them an `}<inlineCode parentName="p">{`id`}</inlineCode>{` so javascript can reference them. Because you know names are unique, you decide to use those for `}<inlineCode parentName="p">{`id`}</inlineCode>{`'s.`}</p>
    <p>{`You're using them for URL's too, so it makes sense. Simplifies `}<a parentName="p" {...{
        "href": "http://backbonejs.org/"
      }}>{`Backbone`}</a>{` routing code.`}</p>
    <p>{`At this point experienced developers get the heebie jeebies. A tiny little voice screaming `}<em parentName="p">{`"Watch out!"`}</em>{` in the back of their head.`}</p>
    <p>{`I couldn't remember why using `}<inlineCode parentName="p">{`name`}</inlineCode>{` felt funny, so I ignored the little voice and barged on. I deployed.`}</p>
    <p>{`Bam. Didn't work.`}</p>
    <p>{`After hours of debugging I finally traced the issue down to spaces in item names. Turns out `}<inlineCode parentName="p">{`id="a word"`}</inlineCode>{` doesn't work. Who'd've thought? (hint: everyone)`}</p>
    <p>{`But that's an easy fix right? Just do something like:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`id="<%= item.name.gsub(' ', '-') %>"
`}</code></pre>
    <p>{`Or add a function to the model. Whatever. The point is, all you have to do is replace spaces with dashes. Simple.`}</p>
    <p>{`But you're wrong. You are creating a slug. It looks easy, but is actually very complicated. Luckily others have solved the problem already. Better than you.`}</p>
    <p>{`A quick Google search reveals a bunch of solutions do in fact exist, but `}<a parentName="p" {...{
        "href": "https://github.com/rsl/stringex"
      }}>{`Stringex`}</a>{` comes out as the best solution for `}<a parentName="p" {...{
        "href": "http://www.ruby-lang.org/",
        "title": "Ruby (programming language)"
      }}>{`Ruby`}</a>{`. There should be plenty for any language you love.`}</p>
    <p>{`Why spend an hour looking for and learning how to use a gem instead of solving the problem in two minutes of coding?`}</p>
    <p>{`Because -> from Stringex's documentation:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`# A simple prelude
"simple English".to_url => "simple-english"
"it's nothing at all".to_url => "its-nothing-at-all"
"rock & roll".to_url => "rock-and-roll"

# Let's show off
"$12 worth of Ruby power".to_url => "12-dollars-worth-of-ruby-power"
"10% off if you act now".to_url => "10-percent-off-if-you-act-now"

# You don't even wanna trust Iconv for this next part
"kick it en Français".to_url => "kick-it-en-francais"
"rock it Español style".to_url => "rock-it-espanol-style"
"tell your readers 你好".to_url => "tell-your-readers-ni-hao"
`}</code></pre>
    <p>{`Impressive to say the least.`}</p>
    <p>{`There's the simple space to dash conversion, but Stringex handles various symbols and common substrings as well. Converting `}<inlineCode parentName="p">{`$12`}</inlineCode>{` to `}<inlineCode parentName="p">{`12-dollars`}</inlineCode>{` strikes me as something particularly useful I'd never come up with.`}</p>
    <p>{`Truth be told, the most advanced slug generation function I've ever come up with (and I've written many) only stripped non-alphanumeric characters from the string before changing spaces to dashes.`}</p>
    <p>{`It sucked.`}</p>
    <p>{`When you find yourself solving a simple problem, look for a gem. Focus your attention to the problem at hand and let others take care of the externalities. You won't be sorry.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=08b189ad-699b-42e3-b0db-11bebd9babfd",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      